import { render, staticRenderFns } from "./buindingLeftBottom.vue?vue&type=template&id=3ba28dee&"
import script from "./buindingLeftBottom.vue?vue&type=script&lang=js&"
export * from "./buindingLeftBottom.vue?vue&type=script&lang=js&"
import style0 from "./buindingLeftBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports